import { z } from "zod";

export const ProbationCycleSchema = z.object({
    cycleId: z.number()
})

export type ProbationCycle = z.infer<typeof ProbationCycleSchema>;